// extracted by mini-css-extract-plugin
export default {"profilePageCont":"Profile_profilePageCont__kPpBN","profilePage":"Profile_profilePage__fQzny"};